export enum EKwikUITextareaSize {
  M = "m",
  L = "l"
}
export const VKwikUITextareaSize = [
  EKwikUITextareaSize.M,
  EKwikUITextareaSize.L
] as const;

export type TKwikUITextareaSize = (typeof VKwikUITextareaSize)[number];
